export default function Testimonial() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden bg-accent-100/50">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20lifestyle%20photography%20of%20a%20person%20happily%20browsing%20products%20on%20a%20tablet%20at%20a%20cozy%20sunlit%20coffee%20shop%20table%2C%20soft%20natural%20window%20light%2C%20cream%20and%20sand%20color%20palette%2C%20genuine%20joyful%20expression%2C%20editorial%20commercial%20photography%2C%20relaxed%20authentic%20atmosphere%2C%20modern%20casual%20style&width=800&height=1000&seq=testimonial-v2&orientation=portrait"
                alt="Satisfied Vigorbuy Spreadsheet user sharing their shopping experience"
                title="Vigorbuy Spreadsheet Community Review"
                className="w-full h-[400px] md:h-[500px] object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div>
            <span className="text-xs font-medium text-foreground-400 tracking-wide">(Community Review)</span>
            <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              What Our Users
              <br />
              <span className="text-foreground-300 font-normal">Are Saying</span>
            </h2>

            <div className="mt-8 md:mt-10">
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed italic">
                &ldquo;I was overwhelmed by the number of products available online until I discovered the Vigorbuy Spreadsheet. It organized everything into clear categories and made product comparison incredibly simple. Now I find exactly what I need in minutes instead of spending hours scrolling through endless listings. The safety guides gave me the confidence to shop smarter.&rdquo;
              </p>
              <p className="mt-5 text-base font-semibold text-foreground-950">
                &mdash; Verified Shopper
              </p>
            </div>

            <div className="mt-8 flex items-center gap-3">
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-5 h-5 flex items-center justify-center text-amber-400">
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                ))}
              </div>
              <span className="text-sm text-foreground-500">Rated 4.9/5 by the community</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}